module.exports = __webpack_public_path__ + "static/img/default-live-disconnection.2a06fc52.png";